export default "__VITE_ASSET__CrCggBeE__"